import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { useGlobalContext } from '../../../../../context/ContextGlobal'
import { TryCatch } from '../../../../../utils/general'
import { updateSubDocument } from '../../../../../firebase/firestore'
import { Path } from '../../../../../router/paths'

export const useClientEditSectors = () => {
  const {
    user,
    setAlerts,
    loading,
    setLoading,
    dataContext,
    // setDataContext, // contexto que guarda dados de lista para a pagina
    infosContext,
    // setInfosContext, // contexto que guarda dados adicionais para a pagina funcionar
    formContext,
    setFormContext, // contexto que guarda dados de formularios da pagina
  } = useGlobalContext()

  const { id } = useParams()

  const [permissions, setPermissions] = useState(formContext?.permissions || {})
  const [checkAlls, setCheckAlls] = useState({})
  const permissionsList = infosContext?.globalPermissions || {}
  const navigate = useNavigate()
  const clientId = user.client.id

  const getFormData = async () => {
    const newFormContext = Object.values(dataContext?.sectors || {}).find((sector) => sector.id === id)
    // console.log()
    await setFormContext(newFormContext)
    await setPermissions(newFormContext.permissions)
  }

  const editSector = async () => {
    const newSetor = { ...formContext, permissions: { ...permissions } }
    await updateSubDocument('clientes', clientId, 'sectors', id, newSetor)

    await setFormContext({})
    setAlerts((prev) => [
      ...prev,
      {
        type: 'success',
        title: 'Setor Editado',
        msg: `O Setor "${newSetor.nome}" foi salvo com sucesso.`,
      },
    ])
    return navigate(Path.ClientSectors)
  }

  const FetchGetFormData = async () => {
    await TryCatch(getFormData, setLoading, setAlerts)
  }

  const HandleEditSector = async () => {
    await TryCatch(editSector, setLoading, setAlerts)
  }

  useEffect(() => {
    FetchGetFormData()
  }, [])

  return {
    loading,
    dataContext,
    formContext,
    setFormContext,
    HandleEditSector,
    permissions,
    setPermissions,
    permissionsList,
    checkAlls,
    setCheckAlls,
  }
}
